// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__HSWza","wrapper":"Gallery_wrapper__-bHly","year":"Gallery_year__3rYUw","gallery":"Gallery_gallery__iEBDh"};